import React from 'react';
import CreatorDashboardReaction from './CreatorDashboardReaction';

function CreatorDashboardReactions(props) {
  return (
    <div className="absolute z-20 top-16 left-24 sm:left-60 right-0 bg-custom-black">
      <div className="text-white font-semibold mt-16 text-lg w-full flex justify-center">
        Reactions
      </div>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center mt-8">
          <div className="flex justify-around items-center w-11/12 h-60 sm:w-6/12 md:bg-gradient-to-br md:from-custom-black md:via-zinc-900 md:to-custom-black rounded-lg">
            <div>
              <CreatorDashboardReaction
                emotes={props.emotes}
                addOrReplaceEmote={props.addOrReplaceEmote}
                removeEmote={props.removeEmote}
                index={0}
              />
              <div className="text-sm sm:text-base text-white flex justify-center text-base">
                Reaction 1
              </div>
            </div>
            <div>
              <CreatorDashboardReaction
                emotes={props.emotes}
                addOrReplaceEmote={props.addOrReplaceEmote}
                removeEmote={props.removeEmote}
                index={1}
              />
              <div className="text-sm sm:text-base text-white flex justify-center text-base">
                Reaction 2
              </div>
            </div>
            <div>
              <CreatorDashboardReaction
                emotes={props.emotes}
                addOrReplaceEmote={props.addOrReplaceEmote}
                removeEmote={props.removeEmote}
                index={2}
              />
              <div className="text-sm sm:text-base text-white flex justify-center text-base">
                Reaction 3
              </div>
            </div>
          </div>
        </div>
        <div
          className="cursor-pointer mt-8 w-60 sm:w-80 bg-blue-600 h-12 rounded-lg font-semibold text-white flex justify-center items-center"
          onClick={async () => await props.submitProfileInfo()}
        >
          Submit
        </div>
      </div>
    </div>
  );
}

export default CreatorDashboardReactions;
